export default __webpack_public_path__ + "995f7edc6b9dd9e2f3067957fb4ce260.svg";